// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__32dIH","OrderButton":"BuildControls_OrderButton__93GaL","enable":"BuildControls_enable__1tVes"};